/** Routes that receive a static SEO HTML file at build time (dist/<route>/index.html). */
export const STATIC_SEO_ROUTES = [
  '/',
  '/services',
  '/mariage',
  '/photobooth',
  '/production',
  '/portfolio',
  '/portfolio/mariage',
  '/portfolio/photobooth',
  '/portfolio/corporate',
  '/portfolio/shooting',
  '/about',
  '/contact',
  '/faq',
  '/photographe-mariage-djerba',
  '/photographe-evenement-tunis',
  '/photobooth-djerba',
  '/video-corporate-tunisie',
  '/photobooth-tunisie',
  '/blog',
  '/blog/photobooth-mariage-tunisie',
] as const;

export type StaticSeoRoute = (typeof STATIC_SEO_ROUTES)[number];

/** Map URL path → service-pages slug (when different). */
export const SERVICE_SLUG_BY_PATH: Record<string, string> = {
  '/services': 'services',
  '/mariage': 'mariage',
  '/photobooth': 'photobooth',
  '/production': 'production',
  '/portfolio/mariage': 'portfolio-mariage',
  '/portfolio/photobooth': 'portfolio-photobooth',
  '/portfolio/corporate': 'portfolio-corporate',
  '/portfolio/shooting': 'portfolio-shooting',
  '/photographe-mariage-djerba': 'photographe-mariage-djerba',
  '/photographe-evenement-tunis': 'photographe-evenement-tunis',
  '/photobooth-djerba': 'photobooth-djerba',
  '/video-corporate-tunisie': 'video-corporate-tunisie',
  '/photobooth-tunisie': 'photobooth-tunisie',
};
